import { Component, OnInit } from '@angular/core';
import {UserPlanService} from "../../../service/userplan.service";
import {BuildingsService} from "../../../service/buildings.service";
import {ActivatedRoute, Router, RouteReuseStrategy} from "@angular/router";
import {environment} from "../../../../environments/environment";
import { Store } from '@ngrx/store';
import { AppState } from '../../../models/app.state';
import { MapsAPILoader } from '@agm/core';
import { BUILDING_RESET } from 'src/app/actions/building.actions';
declare var $ : any;

@Component({
  selector: 'app-mybuilding',
  templateUrl: './mybuilding.component.html',
  styleUrls: ['./mybuilding.component.css']
})
export class MybuildingComponent implements OnInit {

  constructor(private plan : UserPlanService,
              private buildingService: BuildingsService,
              private router: Router,
              private store: Store<AppState>,
              private mapsAPILoader: MapsAPILoader) { }

  //Buildings Variables
  totalBuildings = 0;
  myBuildings = [];
  allBuildings = [];
  buildingList = [];
  placeId;
  add;
  removableData;

  // Get current loggedIn user ID
  id = localStorage.getItem('residents');
  isManager = localStorage.getItem('isManager');
  userBuildingId = localStorage.getItem('userBuildingId');

  apiUrl = environment.apiUrl;
  error;

  ngOnInit() {

    this.buildingService.getAllBuildingsByUserId(this.id).subscribe(
      (buildings) => {
        console.log(buildings)
        if(buildings.success){
          this.myBuildings = buildings.data[0].building;
          this.placeId = this.myBuildings[0].placeId;
          this.buildingList = buildings.data[0].building;
          this.buildingList[0].sanitizeAddress  = this.buildingList[0].adr_address;
          this.totalBuildings = buildings.data[0].building.length;
          if(this.myBuildings.length <= 1){
            this.allBuildings.push(this.myBuildings[0].id);
          }
          this.totalBuildings = this.allBuildings.length;
          console.log("============user building", this.myBuildings, this.placeId);



          this.add = this.buildingList[0].adr_address;;
          let count = 0;
          if (this.add) {
            for (let i = 0; i < this.add.length; i++) {
              if (this.add.charAt(i) == '<') {
                console.log('if');
                break;
              } else {
                count++;
              }
            }
            console.log(count, 'hello');
            this.removableData = this.add.substring(0, count);
            console.log(this.removableData);
            this.add = this.add.replace(this.removableData, '');
            console.log(this.add);
            this.add = this.add.replace(/,/gi, '');
            this.add = this.add.replace(/<\/span> /gi, '</span>,');
            console.log(this.add);
            this.add = this.add.split(',');

          }


        }
      }
    );

  }
  changeBuilding(change){
      this.store.dispatch({type: BUILDING_RESET, payload: []});
      var changeBuildingDetails = {status : change, currentBuildingPlaceId : this.placeId};
      this.plan.setchangeBuildingByRes(changeBuildingDetails);
      $('#addSearchModal .customDis').removeClass('inline');                  
  }

  ngOnDestroy(){
    this.store.subscribe().unsubscribe();
    $('#addSearchModal').modal('hide');
  }
}
